var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/addCustomer" } } },
              [_c("div", { staticClass: "div3" }, [_vm._v("添加客户")])]
            ),
            _c(
              "el-breadcrumb-item",
              {
                attrs: {
                  to: { name: "customerInformation", query: { id: this.id } },
                },
              },
              [_c("div", { staticClass: "div3" }, [_vm._v("客户资料")])]
            ),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "add_order", query: { id: this.id } } } },
              [_c("div", { staticClass: "div3" }, [_vm._v("添加订单")])]
            ),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("添加赠品")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "order" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("订单商品")]),
        _c(
          "el-table",
          { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
          [
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "number", label: "商品数量" },
            }),
            _c("el-table-column", {
              attrs: { prop: "price", label: "商品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "specifications", label: "商品规格" },
            }),
            _c("el-table-column", {
              attrs: { prop: "total", label: "商品小计" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "specify" }, [
      _c("p", { staticClass: "header" }, [_vm._v("选择赠品")]),
      _c(
        "div",
        { staticClass: "search" },
        [
          _c(
            "el-form",
            {
              ref: "address",
              attrs: { inline: true, model: _vm.goods, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "产品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入产品名称" },
                    model: {
                      value: _vm.goods.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.goods, "name", $$v)
                      },
                      expression: "goods.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择品牌" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择产品品牌", clearable: "" },
                      model: {
                        value: _vm.goods.brand,
                        callback: function ($$v) {
                          _vm.$set(_vm.goods, "brand", $$v)
                        },
                        expression: "goods.brand",
                      },
                    },
                    _vm._l(_vm.brandselect, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌分类" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.options,
                      props: {
                        checkStrictly: true,
                        label: "name",
                        value: "id",
                        children: "children",
                      },
                      clearable: "",
                    },
                    model: {
                      value: _vm.goods.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.goods, "type", $$v)
                      },
                      expression: "goods.type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("搜索赠品"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "list" },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.giftL.list } },
            [
              _c("el-table-column", {
                attrs: { prop: "brandId", label: "赠品品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "typeId", label: "赠品分类" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sellPrice", label: "赠品单价" },
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationId", label: "赠品规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "quantityStock", label: "赠品库存" },
              }),
              _c(
                "el-table-column",
                { attrs: { label: "操作" } },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("添加赠品"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("span", { staticClass: "demonstration" }, [_vm._v("共1234页")]),
            _c("span", { staticClass: "demonstration" }, [_vm._v("每页11个")]),
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.currentPage1,
                "page-size": 100,
                layout: "total, prev, pager, next",
                "prev-text": "上一页",
                "next-text": "下一页",
                total: 1000,
              },
              on: {
                "current-change": _vm.handleCurrentChange,
                "update:currentPage": function ($event) {
                  _vm.currentPage1 = $event
                },
                "update:current-page": function ($event) {
                  _vm.currentPage1 = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "giveaway" }, [
      _c("div", { staticClass: "orderBox" }, [
        _c(
          "div",
          { staticClass: "order" },
          [
            _c(
              "p",
              {
                staticClass: "header",
                staticStyle: { background: "#fff", padding: "10px" },
              },
              [_vm._v("订单赠品")]
            ),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "name", label: "赠品名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("p", [_vm._v(_vm._s(scope.row.name))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "赠品数量" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "numer" },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    value: scope.row.number,
                                    min: 1,
                                    max: scope.row.number,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeCount(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.number,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "number", $$v)
                                    },
                                    expression: "scope.row.number",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { slot: "prepend" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeQuantity(
                                            scope.row,
                                            -1
                                          )
                                        },
                                      },
                                      slot: "prepend",
                                    },
                                    [_c("i", { staticClass: "el-icon-minus" })]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { slot: "append" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeQuantity(
                                            scope.row,
                                            1
                                          )
                                        },
                                      },
                                      slot: "append",
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品单价" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("p", [_vm._v(_vm._s(scope.row.address))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "category", label: "商品规格" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "intention", label: "商品小计" },
                }),
                _c(
                  "el-table-column",
                  { attrs: { label: "操作", width: "300" } },
                  [
                    _c("el-button", { attrs: { type: "primary" } }, [
                      _vm._v("删除商品"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "page1" }, [
          _vm._m(0),
          _vm._m(1),
          _c(
            "p",
            [
              _c("span", [_vm._v("总价:")]),
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.total,
                  callback: function ($$v) {
                    _vm.total = $$v
                  },
                  expression: "total",
                },
              }),
            ],
            1
          ),
          _vm._m(2),
          _c(
            "p",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.toReviewOrder },
                },
                [_vm._v("提交订单")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("总计：共 3 件 ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("运费：12 ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("span", { staticStyle: { color: "#999" } }, [_vm._v("原总价：1400")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }